import {AbstractControl, UntypedFormControl, UntypedFormGroup} from '@angular/forms';

import {OnSubmitErrorStateMatcher} from '../../../core/helpers/on-submit-error-state-matcher';
import {Q9Validators} from '@q9elements/ui-kit/validators';
import {TakeUntilComponentDestroy} from '@q9elements/ui-kit/common';

const MIN_PASSWORD_CHARACTERS = 6;

interface MakeReadyFormInterface {
  [key: string]: AbstractControl;
}

export class BaseReadyForForm extends TakeUntilComponentDestroy {
  public form: UntypedFormGroup;
  public havePassword: boolean;
  public error: string;
  public matcher = new OnSubmitErrorStateMatcher();
  public releases;
  public versionRelease;

  public initializeForm(havePassword: boolean): void {
    this.havePassword = havePassword;

    const formFields: MakeReadyFormInterface = {
      release: new UntypedFormControl(this.versionRelease || null),
      comment: new UntypedFormControl(''),
      children: new UntypedFormControl(false)
    };

    if (this.havePassword) {
      formFields.password = new UntypedFormControl('', [
        Q9Validators.required('POPUPS.PASSWORD_REQUIRED'),
        Q9Validators.minLength(MIN_PASSWORD_CHARACTERS, 'POPUPS.VALUE_MIN_LENGTH_PASSWORD')
      ]);
    }

    this.form = new UntypedFormGroup(formFields);
  }
}
